<div *ngIf="selectedPurchaseEventTickets$ | async as eventTickets" class="gb-event-ticket-multi-assign">
  <!-- Presence of event tickets in the purchase indicates payment is not pending -->
  <ng-container *ngIf="eventTickets.length; else paymentPending">
    <mat-dialog-content>
      <div class="callout-container">
        <gb-callout color="primary">
          <div class="callout-content">
            <div>
              <mat-icon class="check-circle" color="primary">check_circle</mat-icon>
            </div>
            <div>
              <h3 translate="SHARED.EVENT_TICKETS.MULTI_ASSIGN.ORDER_CONFIRMED_HEADER"></h3>
              <p
                [translate]="
                  isAdminOrVolunteer
                    ? 'SHARED.EVENT_TICKETS.MULTI_ASSIGN.ORDER_CONFIRMED_DESCRIPTION_ADMIN'
                    : 'SHARED.EVENT_TICKETS.MULTI_ASSIGN.ORDER_CONFIRMED_DESCRIPTION'
                "
              ></p>
            </div>
          </div>
        </gb-callout>

        <mat-expansion-panel
          *ngFor="let eventTicket of eventTickets | gbOrderBy: 'seat_number'; let i = index; trackByProperty: 'uuid'"
          class="minimal-panel"
          [expanded]="isExpanded[eventTicket.uuid]"
          (opened)="isExpanded[eventTicket.uuid] = true"
          (closed)="isExpanded[eventTicket.uuid] = false"
        >
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon [color]="getIconColor(eventTicket)">confirmation_number</mat-icon>
              <h3>
                {{ eventTicket.seat_number | gbEventTicketSeatLabel }}
                {{ getGuestName(eventTicket) }}
              </h3>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <gb-event-ticket-guest-form
            [eventTicket]="eventTicket"
            [shouldPrepopulateForm]="eventTicket.seat_number === 1"
            [isMultiAssign]="eventTicket.seat_number > 1"
            buttonLabel="COMPLETE"
            (onSelfAssignedChange)="onSelfAssignChange($event, eventTicket)"
            (formReady)="guestForms[eventTicket.uuid] = $event"
          ></gb-event-ticket-guest-form>

          <div *ngIf="shouldShowQuestionsForm(eventTicket)" class="animated">
            <gb-event-ticket-questions-form
              [customFields$]="selectedPurchaseCustomFields$"
              [index]="i"
              [allOptional]="!isSelfAssigned[eventTicket.uuid] || isAdminOrVolunteer"
              (formReady)="questionsForms[eventTicket.uuid] = $event"
            ></gb-event-ticket-questions-form>
          </div>
        </mat-expansion-panel>
      </div>
    </mat-dialog-content>

    <div class="button-container">
      <div>
        <button
          mat-raised-button
          color="primary"
          translate="COMPLETE"
          type="button"
          (click)="onSubmit(eventTickets)"
        ></button>
        <div class="skip-container">
          <span translate="SHARED.EVENT_TICKETS.STEPPER.SKIP_TEXT"> </span>
          <a translate="SHARED.EVENT_TICKETS.MULTI_ASSIGN.SKIP_LINK" (click)="onSkip()" class="primary-link"> </a>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-template #paymentPending>
    <gb-payment-pending
      *ngIf="selectedPurchaseId$ | async as purchaseId"
      [isPaymentPending$]="isPaymentPending$"
      (onPaymentPendingDelayed)="syncEventTicketPurchase(purchaseId)"
    ></gb-payment-pending>
  </ng-template>
</div>
